import Box from '@material-ui/core/Box';
import { SubdivisionOverrideTypeEnum } from '@vatos-pas/common';
import { RadioButtonGroup } from '../RadioButtonGroup';

type OverrideTypeRadioProps = {
  disabled?: boolean;
  onOverrideTypeChange: (value: SubdivisionOverrideTypeEnum) => void;
  value?: SubdivisionOverrideTypeEnum;
};

export const OverrideTypeRadio = ({
  disabled = false,
  onOverrideTypeChange,
  value,
}: OverrideTypeRadioProps) => {
  return (
    <Box mb={2}>
      <RadioButtonGroup
        source="overrideType"
        onChange={(newValue: SubdivisionOverrideTypeEnum) => {
          onOverrideTypeChange(newValue);
        }}
        disabled={disabled}
        choices={[
          {
            id: SubdivisionOverrideTypeEnum.OFFSET,
            label: 'Offset (Adjusted Region)',
          },
          {
            id: SubdivisionOverrideTypeEnum.FIXED,
            label: 'Fixed',
          },
        ]}
        value={value || SubdivisionOverrideTypeEnum.OFFSET}
      />
    </Box>
  );
};
